const listeners = [];
let nextId = 1;

const DEFAULT_DURATION = 2600;

const emit = (kind, content, duration = DEFAULT_DURATION) => {
  const id = nextId++;
  listeners.forEach((listener) => listener({ id, kind, content, duration }));
};

export const subscribeFeedback = (listener) => {
  listeners.push(listener);
  return () => {
    const index = listeners.indexOf(listener);
    if (index >= 0) {
      listeners.splice(index, 1);
    }
  };
};

export const message = {
  success(content, duration) {
    emit('success', content, duration);
  },
  error(content, duration) {
    emit('error', content, duration);
  },
  info(content, duration) {
    emit('info', content, duration);
  },
  warn(content, duration) {
    emit('warn', content, duration);
  },
  warning(content, duration) {
    emit('warn', content, duration);
  }
};

export const notification = {
  success({ message: title, description, duration }) {
    emit('success', title ? `${title}${description ? ` - ${description}` : ''}` : description, duration ? duration * 1000 : undefined);
  },
  error({ message: title, description, duration }) {
    emit('error', title ? `${title}${description ? ` - ${description}` : ''}` : description, duration ? duration * 1000 : undefined);
  },
  info({ message: title, description, duration }) {
    emit('info', title ? `${title}${description ? ` - ${description}` : ''}` : description, duration ? duration * 1000 : undefined);
  },
  warn({ message: title, description, duration }) {
    emit('warn', title ? `${title}${description ? ` - ${description}` : ''}` : description, duration ? duration * 1000 : undefined);
  },
  warning({ message: title, description, duration }) {
    emit('warn', title ? `${title}${description ? ` - ${description}` : ''}` : description, duration ? duration * 1000 : undefined);
  }
};
